import React, { useEffect, useState } from 'react'
import { CheckBox, FormCustom, Input, SwitchToggle } from '../../../components/form'
import ReactPlaceholder from 'react-placeholder/lib'
import { useGetId, useSaveUpdate } from '../../../hooks/process-data'
import { useMemo } from 'react'
import { doRequestGet, doRequestPost } from '../../../api'
import { apiResource, doToast } from '../../../utils'
import { toast } from 'react-toastify'
import { Button } from 'react-bootstrap'
import SelectCustom from '../../../components/select-custom/SelectCustom'

const WorkerForm = ({ rowId, setReload }) => {
  const [row, setRow] = useState({
    p_id_worker: '',
    p_id_company: '',
    p_name_worker: '',
    p_last_name_worker: '',
    p_enabled_worker: 0,
    p_photo_worker: [],
    p_photo_worker_path: '',
    p_email_worker: '',
    p_phone_worker: '',
    p_password_worker: '',
    p_username_user: '',
    p_id_profile: '',
    p_id_branch_office: '',
    p_branch_office: [],
    p_event: [],
  })
  const [ready, setReady] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [profiles, setProfiles] = useState([]);
  const [passwordBlocked, setPasswordBlocked] = useState(true);
  const [typeFieldPassword, setTypeFieldPassword] = useState('password')
  const [branchOffices, setBranchOffices] = useState([])
  const [events, setEvents] = useState([])

  const dataSubmit = useMemo(() => {
    let formData = new FormData();

    for (const key in row) {
      if (key === 'p_photo_worker') {
        if (row.p_photo_worker.length > 0) {
          formData.append(key, row[key][0]);
        }
      } else if (key === 'p_branch_office') {
        formData.append(key, JSON.stringify(row[key]));
      } else if (key === 'p_event') {
        formData.append(key, JSON.stringify(row[key]));
      } else {
        formData.append(key, row[key]);
      }
    }

    return formData;
  }, [row])

  const { doSubmit, setDoSubmit } = useSaveUpdate({
    data: dataSubmit,
    url: '/worker',
    hasFile: true,
    setReload
  })

  const { isProcessing, getRow, error } = useGetId({
    url: '/worker/' + rowId,
    rowId: rowId
  })

  useEffect(() => {
    const getData = async function () {
      if (error) {
        setReload();
      } else {
        if (!isProcessing && !ready) {
          const getProfiles = await doRequestGet({
            url: '/profile'
          })
          setProfiles(getProfiles.data)

          const getBranchOffices = await doRequestGet({
            url: '/branch-office/public'
          })
          setBranchOffices(getBranchOffices.data)

          const getEvents = await doRequestPost({
            url: '/event/get/public'
          })
          setEvents(getEvents.data)

          if (rowId) {
            setRow({
              p_id_worker: getRow.id_worker,
              p_id_company: getRow.id_company,
              p_name_worker: getRow.name_worker,
              p_last_name_worker: getRow.last_name_worker,
              p_enabled_worker: getRow.enabled_worker,
              p_photo_worker: [],
              p_photo_worker_path: getRow.photo_worker,
              p_email_worker: getRow.email_worker,
              p_phone_worker: getRow.phone_worker,
              p_password_user: '',
              p_username_user: getRow.username_user,
              p_id_profile: getRow.id_profile,
              p_id_branch_office: getRow.id_branch_office,
              p_branch_office: getRow.branch_office ? getRow.branch_office : [],
              p_event: getRow.event ? getRow.event : [],
            })
          } else {
            setPasswordBlocked(false)
          }
          setReady(true);
        }
      }
    }

    getData();
  }, [isProcessing, getRow, error, setReload, rowId, ready])

  return <ReactPlaceholder ready={ready} rows={5}>
    <FormCustom onSubmit={() => {
      if (!row.p_id_branch_office) {
        doToast({
          response: 'warning',
          message: 'Debe seleccionar una sucursal',
          toast
        })
        return
      }

      if (!row.p_id_profile) {
        doToast({
          response: 'warning',
          message: 'Debe seleccionar un perfil',
          toast
        })
        return
      }

      setDoSubmit(true)
    }} loadSubmit={doSubmit}>
      <Input
        text="Nombres"
        placeholder="Nombres"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_name_worker}
        onChange={e => setRow({ ...row, p_name_worker: e.target.value })}
        maxLength={100}
      />
      <Input
        text="Apellidos"
        placeholder="Apellidos"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_last_name_worker}
        onChange={e => setRow({ ...row, p_last_name_worker: e.target.value })}
        maxLength={100}
      />
      <Input
        text="Email"
        placeholder="Email"
        type="email"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_email_worker}
        onChange={e => setRow({ ...row, p_email_worker: e.target.value })}
        maxLength={150}
      />
      <Input
        text="Telefono"
        placeholder="Telefono"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_phone_worker}
        onChange={e => setRow({ ...row, p_phone_worker: e.target.value })}
        maxLength={20}
      />
      <Input
        text="Nombre de Usuario"
        placeholder="Nombre de Usuario"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_username_user}
        onChange={e => setRow({ ...row, p_username_user: e.target.value })}
        maxLength={20}
        readOnly={!isNaN(parseInt(row.p_id_worker))}
      />
      {!isNaN(parseInt(row.p_id_worker)) && <CheckBox
        id="enabled-password"
        text="¿Cambiar Contraseña?"
        classNameParent="col-12"
        checked={!passwordBlocked}
        onChange={_ => {
          setPasswordBlocked(!passwordBlocked)
          setRow({ ...row, p_password_user: '' })
        }}
      />}
      <Input
        text="Contraseña"
        placeholder="Contraseña"
        type={typeFieldPassword}
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_password_user}
        onChange={e => setRow({ ...row, p_password_user: e.target.value })}
        maxLength={20}
        readOnly={passwordBlocked}
        append={!passwordBlocked ? [<Button variant="dark" onClick={_ => {
          setTypeFieldPassword(typeFieldPassword === 'password' ? 'text' : 'password')
        }}>
          {typeFieldPassword === 'text' ? <i className='fa fa-eye-slash'></i> : <i className="fas fa-eye"></i>}
        </Button>] : []}
      />
      <SelectCustom
        valueId={row.p_id_profile}
        keyName="profile"
        options={profiles}
        setRow={setRow}
        row={row}
        selectText="Perfil"
        selectPops={{
          classNameParent: 'col-12 mb-3',
        }}
      />
      <SelectCustom
        valueId={row.p_id_branch_office}
        keyName="branch_office"
        options={branchOffices}
        setRow={setRow}
        row={row}
        selectText="Sucursal"
      />
      <Input
        type="file"
        text="Foto"
        classNameParent="col-12 mb-3"
        required={rowId === ''}
        invalid="El campo es obligatorio."
        onChange={e => {
          const files = e.target.files
          setRow({ ...row, p_photo_worker: files })
          setPreviewImage(files.length > 0 ? URL.createObjectURL(files[0]) : null)
        }}
        accept="image/*"
      />
      {(row.p_photo_worker_path || previewImage) && <div className='col-12 mb-3'>
        <small className='text-muted'>
          Vista Previa
        </small>
        <div>
          <img src={previewImage ? previewImage : (apiResource({
            url: row.p_photo_worker_path
          }))} alt={row.p_name_worker} className="max-width-200 rounded" />
        </div>
      </div>}
      <SwitchToggle
        id="worker-enabled"
        textCheck="Desactivar"
        textUnChecked="Activar"
        classNameParent="col-12 mb-3"
        checked={row.p_enabled_worker === 1}
        onChange={e => setRow({ ...row, p_enabled_worker: e.target.checked ? 1 : 0 })}
      />
      <SelectCustom
        valueId={row.p_branch_office}
        keyName="branch_office"
        options={branchOffices}
        setRow={setRow}
        row={row}
        selectText="Seleccionar sucursales para la venta"
        selectPops={{
          classNameParent: 'col-md-12 mb-3',
        }}
        isMulti
        showEnabled={true}
        isSort={false}
      />
      <SelectCustom
        valueId={row.p_event}
        keyName="event"
        options={events}
        setRow={setRow}
        row={row}
        selectText="Seleccionar evento para la venta"
        selectPops={{
          classNameParent: 'col-md-12 mb-3',
        }}
        isMulti
        showEnabled={false}
        isSort={false}
      />
    </FormCustom>
  </ReactPlaceholder>
}

WorkerForm.defaultProps = {
  rowId: '',
  setReload: () => { },
}

export {
  WorkerForm
};